export default "__VITE_ASSET__HKgcFIAa__"